import { useState, useEffect } from 'react';

export function useInfiniteScroll (props) {
  const { currentPath, getAllDocuments, getMoreDocuments } = props;
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [noMoreData, setNoMoreData] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [nextToken, setNextToken] = useState(undefined);

  const [fetch, setFetch] = useState(null);
  const search = props.filter.pending || props.filter.finished;

  useEffect(() => {
    async function getListDocuments () {
      try {
        setLoading(true);
        setLoadingData(true);
        const result = await getAllDocuments();
        setNextToken(result.data.listDocuments.nextToken);
        if (result && !result.data.listDocuments.nextToken) {
          setNoMoreData(true);
        }
      } catch (error) {
        console.error('Error occurred while fetching document····', error);
      } finally {
        setLoading(false);
        setLoadingData(false);
      }
    }

    setNoMoreData(false);
    document.addEventListener('scroll', onScroll);
    getListDocuments();
    return () => {
      setFetch(false);
      document.removeEventListener('scroll', onScroll);
    };
  }, [currentPath, search]);

  useEffect(() => {
    async function getListDocumentsMore (currentPage, search) {
      setLoadingMore(true);
      setLoadingData(true);
      try {
        const result = await getMoreDocuments(currentPage, search, 'document', nextToken);
        setNextToken(result.data.listDocuments.nextToken);

        if (result && !result.data.listDocuments.nextToken) {
          setNoMoreData(true);
        }
      } catch (error) {
        console.error('Error occurred while fetching more document···', error);
      } finally {
        setLoadingMore(false);
        setFetch(false);
        setLoadingData(false);
      }
    }

    if (fetch && !noMoreData && !loadingData) {
      getListDocumentsMore(currentPath, search);
    }
  }, [fetch]);

  function onScroll () {
    if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) {
      setFetch(true);
    }
  }

  return [loading, loadingMore, noMoreData];
}
